﻿﻿export interface IExecutiveSponsor {
    id: number;
    name: string;
    abbreviation: string;
}
